import { TRIGGER_WORDS } from '../constants/common';

export const checkTriggerWords = (text: string): boolean => {
  if (text) {
    return TRIGGER_WORDS.some((word) => text.toLowerCase().includes(word.toLowerCase()));
  }
  return false;
};

export const toUpperFirstSymbol = (text: string): string => {
  return text[0].toUpperCase() + text.slice(1);
};
